import { AxiosResponse } from "axios";
import { RestServiceConnection } from "../restServiceConnection";

const DASHBOARD_ENDPOINT = "/dashboard";

export class DashboardService extends RestServiceConnection {


    // -----------------------------------------------------------------------------------------------------------------
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // -----------------------------------------------------------------------------------------------------------------
    // @ES Servicios relacionados con recogidas
    // @EN Services related to pickups
    // -----------------------------------------------------------------------------------------------------------------
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // -----------------------------------------------------------------------------------------------------------------

    // -----------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene el numero de recogidas satisfactorias e insatisfactorias en un periodo de tiempo
     *
     * @EN Gets the number of successful and unsuccessful pickups in a time period
     */
    // -----------------------------------------------------------------------------------------------------------------
    satisfactoryAndUnsatisfactoryPickups = async (time: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: DASHBOARD_ENDPOINT + "/satisfactory-and-unsatisfactory-pickups",
            data: time
        }, true) as AxiosResponse;
        return this;
    }
    // -----------------------------------------------------------------------------------------------------------------


    // -----------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene la comparativa de recogidas satisfactorias vs planeadas en un periodo de tiempo
     *
     * @EN Gets the comparison of successful vs planned pickups in a time period
     */
    // -----------------------------------------------------------------------------------------------------------------
    completedVsPlannedPickupsPercentage = async (time: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: DASHBOARD_ENDPOINT + "/completed-pickups-vs-planned-pickups-percentage",
            data: time
        }, true) as AxiosResponse;
        return this;
    }
    // -----------------------------------------------------------------------------------------------------------------


    // -----------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene el volumen total de aceite recogido en un periodo de tiempo
     *
     * @EN Gets the total volume of oil collected in a time period
     */
    // -----------------------------------------------------------------------------------------------------------------
    totalOilVolumeCollected = async (time: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: DASHBOARD_ENDPOINT + "/total-oil-volume-collected",
            data: time
        }, true) as AxiosResponse;
        return this;
    }
    // -----------------------------------------------------------------------------------------------------------------


    // -----------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene el ranking de sedes según el volumen de aceite recogido en un periodo de tiempo
     *
     * @EN Gets the ranking of headquarters by volume of oil collected in a time period
     */
    // -----------------------------------------------------------------------------------------------------------------
    oilCollectedRankingByHeadquarter = async (time: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: DASHBOARD_ENDPOINT + "/headquarter-oil-collection-ranking",
            data: time
        }, true) as AxiosResponse;
        return this;
    }
    // -----------------------------------------------------------------------------------------------------------------


    // -----------------------------------------------------------------------------------------------------------------
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // -----------------------------------------------------------------------------------------------------------------
    // @ES Servicios relacionados con vehículos
    // @EN Services related to vehicles
    // -----------------------------------------------------------------------------------------------------------------
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // -----------------------------------------------------------------------------------------------------------------


    // -----------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene el consumo total de combustible en litros por vehículo en un periodo de tiempo
     *
     * @EN Gets the total fuel consumption in liters per vehicle in a time period
     */
    // -----------------------------------------------------------------------------------------------------------------
    fuelLitresUsedPerVehicle = async (time: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: DASHBOARD_ENDPOINT + "/fuel-litres-used-per-vehicle",
            data: time
        }, true) as AxiosResponse;
        return this;
    }
    // -----------------------------------------------------------------------------------------------------------------


    // -----------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene el consumo medio de combustible en litros por kilómetro y por vehículo en un periodo de tiempo
     *
     * @EN Gets the average fuel consumption in liters per kilometer and per vehicle in a time period
     */
    // -----------------------------------------------------------------------------------------------------------------
    averageConsumptionPerKilometrePerVehicle = async (time: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: DASHBOARD_ENDPOINT + "/average-consumption-per-kilometre-per-vehicle",
            data: time
        }, true) as AxiosResponse;
        return this;
    }
    // -----------------------------------------------------------------------------------------------------------------


    // -----------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene el coste acumulado de mantenimiento por vehículo en un periodo de tiempo
     *
     * @EN Gets the accumulated maintenance cost per vehicle in a time period
     */
    // -----------------------------------------------------------------------------------------------------------------
    accumulatedMaintenanceCostsPerVehicle = async (time: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: DASHBOARD_ENDPOINT + "/accumulated-maintenance-costs-per-vehicle",
            data: time
        }, true) as AxiosResponse;
        return this;
    }
    // -----------------------------------------------------------------------------------------------------------------


    // -----------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene el número de repostajes por usuario y vehículo en un periodo de tiempo
     *
     * @EN Gets the number of refuellings per user and vehicle in a time period
     */
    // -----------------------------------------------------------------------------------------------------------------
    refuellingPerUserAndVehicle = async (time: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: DASHBOARD_ENDPOINT + "/refuelling-per-user-and-vehicle",
            data: time
        }, true) as AxiosResponse;
        return this;
    }
    // -----------------------------------------------------------------------------------------------------------------



    // -----------------------------------------------------------------------------------------------------------------
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // -----------------------------------------------------------------------------------------------------------------
    // @ES Servicios relacionados con productos
    // @EN Services related to products
    // -----------------------------------------------------------------------------------------------------------------
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // -----------------------------------------------------------------------------------------------------------------



    // -----------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene la cantidad de productos entregados a proveedores en un periodo de tiempo
     *
     * @EN Gets the quantity of products delivered to providers in a time period
     */
    // -----------------------------------------------------------------------------------------------------------------
    productQuantityDeliveredToProviders = async (time: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: DASHBOARD_ENDPOINT + "/product-quantity-delivered-to-providers",
            data: time
        }, true) as AxiosResponse;
        return this;
    }
    // -----------------------------------------------------------------------------------------------------------------


    // -----------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene los movimientos de stock por producto en un periodo de tiempo
     *
     * @EN Gets the stock movements per product in a time period
     */
    // -----------------------------------------------------------------------------------------------------------------
    stockMovementsPerProduct = async (time: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: DASHBOARD_ENDPOINT + "/stock-movements-per-product",
            data: time
        }, true) as AxiosResponse;
        return this;
    }
    // -----------------------------------------------------------------------------------------------------------------


    // -----------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene los productos con stock por debajo del mínimo en un periodo de tiempo
     *
     * @EN Gets the products with stock below the minimum in a time period
     */
    // -----------------------------------------------------------------------------------------------------------------
    productsWithMinimumStock = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: DASHBOARD_ENDPOINT + "/products-with-minimum-stock",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -----------------------------------------------------------------------------------------------------------------

    // -----------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene las estadísticas de los proveedores
     *
     * @EN Gets the provider statistics
     */
    // -----------------------------------------------------------------------------------------------------------------
    providerStatistics = async () => {
        this.response = await this.makeRequest({
            method: "POST",
            url: DASHBOARD_ENDPOINT + "/provider-statistics",
        }, true) as AxiosResponse;
        return this;
    }
    // -----------------------------------------------------------------------------------------------------------------
}